@if (formGroup) {
  <form [formGroup]="formGroup" (ngSubmit)="save()">
    <dialog class="bm-modal" open (document:keydown.escape)="closeModal.emit()">
      <div class="bm-modal-box max-h-[80vh] overflow-y-auto">
        <ng-container *ngTemplateOutlet="tplFormContent" />
        <div class="bm-modal-action">
          <button class="bm-btn bm-btn-secondary" type="button" (click)="closeModal.emit()">Abbrechen</button>
          <button class="bm-btn bm-btn-primary" [disabled]="!formGroup.valid">Speichern</button>
        </div>
      </div>
    </dialog>

    <ng-template #tplFormContent>
      <h4 class="text-lg font-bold me-auto my-auto">Materialanforderung erstellen</h4>
      <fieldset class="bm-card bm-card-sm bm-fieldset px-0">
        <label class="bm-fieldset-label">Filter</label>
        <select
          class="bm-select"
          [(ngModel)]="selectedTemplateFilter"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="updateFilteredTemplates()"
        >
          <option [value]="'all'">Alle</option>
          <option [value]="'exclusive_project'">Nur Projekt-Templates</option>
          <option [value]="'inclusive_project'">Projekt/Unspezifizierte Templates</option>
        </select>

        <label class="bm-fieldset-label">Template*</label>
        <mat-form-field appearance="outline" class="outline-small no-subscript flex-4 relative" style="width: 320px">
          <mat-select formControlName="article_template_id">
            <div>
              <input
                class="bm-input"
                style="margin: 0 4px 6px 4px; width: calc(100% - 8px)"
                type="search"
                placeholder="Suche Template..."
                [(ngModel)]="templateSearchText"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateFilteredTemplates()"
                (search)="updateFilteredTemplates()"
              />
              <div style="flex: 1; overflow-y: auto">
                <mat-option style="font-size: 0.8rem !important">None</mat-option>
                @for (template of filteredTemplates; track template) {
                  <mat-option style="font-size: 0.8rem !important" [value]="template.id">{{
                    template.description
                  }}</mat-option>
                }
              </div>
            </div>
          </mat-select>
        </mat-form-field>

        <label class="bm-fieldset-label">Menge*</label>
        <input class="bm-input" type="number" min="1" formControlName="amount" />
      </fieldset>
    </ng-template>
  </form>
}
